import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Picture from '@nmx/template/dist/componentLibrary/components/Picture';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import ApLogo from './images/logo-media-ap.png';
import BloombergLogo from './images/logo-media-bloomberg.png';
import ReutersLogo from './images/logo-media-reuters.png';
// styles
import { ColStyled } from './styles';

export default () => {
  return (
    <SectionContainer
      id='private-wealth-management-thought-leaders'
      backgroundVariant='lightA'
      themeType='lightTheme'>
      <Row align='center'>
        <Col medium={8}>
          <Typography
            component='h2'
            accent='pcgHeading'
            branding='pcg'
            align='center'
            nextElement='typography'
            disableBottomPadding>
            Work with experts in financial <WidowBlock>thought leadership.</WidowBlock>
          </Typography>
          <Typography nextElement='graphic'>
            When major market movements happen, our Wealth Management Investment Team is called upon by national news and media outlets to provide their expertise. Our Private Client Group advisors work with them, including our Chief Investment Strategist, Brent Schutte, to bring their insights and philosophy into your portfolio.
          </Typography>
        </Col>
      </Row>
      <Row align='center'>
        <Col
          xsmall={6}
          medium={12}
          large={10}>
          <Row align='center'>
            <ColStyled medium={4}>
              <Picture
                src={BloombergLogo}
                altText='Bloomberg logo'
              />
            </ColStyled>
            <ColStyled medium={4}>
              <Picture
                src={ReutersLogo}
                altText='Reuters logo'
              />
            </ColStyled>
            <ColStyled medium={4}>
              <Picture
                src={ApLogo}
                altText='Associated Press logo'
              />
            </ColStyled>
          </Row>
        </Col>
      </Row>
    </SectionContainer>
  );
};
